export default __webpack_public_path__ + "static/media/loading.b7ac36a1.png";